import { render, staticRenderFns } from "./RecommendationCard.vue?vue&type=template&id=5384c0bf&scoped=true&"
import script from "./RecommendationCard.vue?vue&type=script&lang=js&"
export * from "./RecommendationCard.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationCard.vue?vue&type=style&index=0&id=5384c0bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384c0bf",
  null
  
)

export default component.exports